import React from "react";

const Bhk = ({ selectedBedrooms = [], handleBedroomPress }) => {
  const bhkapartments = [
    { id: "1", name: "1 RK / 1 BHK" },
    { id: "2", name: "2 BHK" },
    { id: "3", name: "3 BHK" },
    { id: "4", name: "4 BHK" },
    { id: "5", name: "4+ BHK" },
  ];

  return (
    <div className="mainbarfiltercomponents">
      {bhkapartments.map((bhk, index) => {
        const isChecked = selectedBedrooms.includes(bhk.id);
        return (
          <div
            className="propertyboxes"
            key={index}
            onClick={() => handleBedroomPress && handleBedroomPress(bhk.id)}
            style={{ cursor: "pointer" }}
          >
            <input
              type="checkbox"
              checked={isChecked}
              onChange={() => {}}
              style={{ cursor: "pointer" }}
            />
            <p className="propertytextpara" style={{ margin: 0, paddingLeft: "8px" }}>
              {bhk.name}
            </p>
          </div>
        );
      })}
    </div>
  );
};

export default Bhk;
